import React, { Component } from 'react';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import { Row, Col, Button, Table, Pagination } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import DoubleScreen from './DoubleScreen';
import { addDays } from 'date-fns';
import moment from "moment";
export default class SearchCSATRecord extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      activePage:1
    }
    this.bulkclientName=[]
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){    
        let centerName = _.filter(selectedregionName.userCenters);
        return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName=[];
    if(!_.isEmpty(selectedcenterName)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return  _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
  }
  handleChangeStart = (date) => {
   // date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
    
    if(!_.isEqual(this.state.startDate, date)){
      this.setState({endDate:''})
    }
  }
  handleChangeEnd = (e) => {
   // e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
  mobileChange = (e) => {
    this.setState({selectedmobile:e.target.value})
  }
  handleDoubleClick = (i, id) => { 
    this.setState({['showDouble'+i]:true})
    this.props.action.csatScoreCalculation(id)
  }
  onClose = (i) => {
    this.setState({['showDouble'+i]:false})
  }
  renderInboxValues = (data, startOffset, startCount, Per_Page) => { 
    if(!_.isEmpty(data)){
     return _.map(data, (obj, index) =>{  
      if(index >= startOffset & startCount < Per_Page){
        startCount++;
        return(
        <tr onDoubleClick={()=>this.handleDoubleClick(index, obj.transactionNo)}>
          {this.state['showDouble'+index] ? <DoubleScreen closeModal={()=>this.onClose(index)} object={obj.values} loginUserName={this.props.loginUserName}
            action={this.props.action} ScoreCalculation={this.props.ScoreCalculation}
            /> 
          : null}
          <td>{obj.transactionNo}</td>
          <td>{obj.date}</td>            
          <td>{obj.agentName}</td>
          <td>{obj.skillSet}</td>
          <td>{obj.tlName}</td>           
          <td>{obj.issueResolved}</td>   
          <td>{obj.overallCallRating}</td>
          <td>{obj.callType}</td>     
          <td>{obj.overallScore}</td> 
          <td>{obj.csatDoneBy}</td>     
        </tr>)
       }                     
      })
    } else {
      return(<tr><td colSpan="9">No Records Found</td></tr>)
    }
  }
  validateForm = () =>{    
    const {startDate, endDate} = this.state;
      if((typeof startDate !== 'undefined')  && (typeof endDate !== 'undefined')){
        return true }
    }
  SearchTemplate = () => {  
    const {selectedregionName, selectedcenterName, selectedclientName, startDate, endDate} = this.state;
    let x;
    let process = _.find(this.props.inventoryCsat.processes, {label: "CSAT"})
    if(!_.isEmpty(process)){
      x = process.id  } else {
     x = {'processId':"", "processName":""}
   }  
    let obj = {
      'region': {'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
      'centerIds': _.map(selectedcenterName, (x) =>{return x.inventoryCenterId}),
      'clientIds': _.map(selectedclientName, (x) =>{return x.inventoryClientId}),
      'processIds': [x],
     // 'mobile': mobile,
     'startDate':moment(startDate).format('YYYY-MM-DD'),
     'endDate':moment(endDate).format('YYYY-MM-DD'),
    }
    this.props.action.TokenValidation()     
    this.props.action.actionSearchCompleted(obj)
    this.setState({search:true})

  }
  resetTemplate = () =>{
    this.setState({
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      startDate:null,
      endDate:null,
      search:false,
      activePage:1
    })
  }
  valueReturn = () => {
    let retunOBj = [];
    if(!_.isEmpty(this.state.selectedclientName)){
      retunOBj = _.map(this.state.selectedclientName, (obj) => {
        return (_.find(obj.userProcesses, {inventoryProcessName: "CSAT"}) ?
         {'inventoryProcessName':'CSAT'} : [])
      })      
     
    }
    if(_.some(retunOBj, {inventoryProcessName: "CSAT"})){
      return {inventoryProcessName: "CSAT"}
    } else {
      return ['No CSAT Process Mapped']
    }
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
  }
  handleSelectPaginationPrev = () => {
    const {activePage} = this.state;
    this.setState({
      activePage: activePage-1,
    });
  }
  handleSelectPaginationNext = () => {
    const {activePage} = this.state;
    this.setState({
      activePage: activePage+1,
    });
  }
  render(){
    const {search, activePage} = this.state;
    const Per_Page=50;  
    let totalPages = 1
    if(!_.isEmpty(this.props.searchData)){
      totalPages = Math.ceil(this.props.searchData.length/Per_Page)
    }
    let items = []; 
    const startOffset = (this.state.activePage-1) * Per_Page;
    let startCount = 0;
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
    }
    return(
    <div>
      <Row>
      <Col>
        <label>Region Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
    </Row> 
      <Row>
      <Col>
        <label>Center Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
        multiple={true}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>             
    </Row>
      <Row>
      <Col>
        <label>Client Name</label>
      </Col>
      <Col>
    <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
      multiple={true}
      includeSelectAll={false}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
    </Row> 
      <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.valueReturn()}
      // options={_.filter(this.props.inventoryCsat.processes, {label: "CSAT"})}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
      multiple={false}
      includeSelectAll={false}
      placeholder='Select Process Name'
      dropdownHeight={600}
    />
     </Col>
     </Row> 
      <Row>
        <Col>
        <label>Date Range<span className='RedColoring'>*</span></label>
       </Col>
        <Col className='myContainter'>
        <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           endDate={this.state.endDate}
           onChange={this.handleChangeStart}
           maxDate={addDays(this.state.startDate, 14)}
           placeholderText="Select a date Range"
          />
        <DatePicker
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
          maxDate={addDays(this.state.startDate, 14)}
          placeholderText="Select a date Range"
          />    
       </Col> 
     </Row> 
      <br/>
     <center><Button onClick={this.SearchTemplate} className='buttonwidth' disabled={!this.validateForm()}>Search</Button>&nbsp;
     <Button onClick={this.resetTemplate} className='buttonwidth'>Reset</Button>
     </center>
        {((search)) ?  
        <p className='calibration'>
        <Table responsive>
          <thead>
            <th>TRANSACTION NO</th>              
            <th>TRANSACTION DATE</th>    
            <th>AGENT NAME</th>  
            <th>AGENT SKILLSET</th>
            <th>TL NAME</th>
            <th>ISSUE RESOLVED</th>
            <th>OVERALL CALL RATING</th>
            <th>CALL TYPE</th>
            <th>OVERALL SCORE</th>
            <th>CSAT DONE BY</th>
          </thead>
          <tbody>
            { this.renderInboxValues(_.cloneDeep(this.props.searchData), startOffset, startCount, Per_Page)}    
          </tbody>
        </Table>
        {!_.isEmpty(items) ?
    <Pagination>
			<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
			<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
			<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
		  <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
		</Pagination> : null}
       
       </p>: null}      
  </div>)
  }
}